export const MAX_IMAGES_PER_SECTION = 6;

// Mock categories - adjust these based on your actual needs
export const GALLERY_KEYS_TO_ID = {
  "all-all": 0,
  "cosmetic-all": 1,
  "cosmetic-veneers": 2,
  "cosmetic-whitening": 3,
  "restorative-all": 4,
  "restorative-implants": 5,
  "restorative-crowns": 6,
  "orthodontic-all": 7,
  "orthodontic-braces": 8,
  "orthodontic-invisalign": 9,
} as const;

export const FILTERS_ARRAY = [
  "all",
  "cosmetic",
  "restorative",
  "orthodontic",
] as const;

export const DESTINATIONS_ARRAY = [
  "all",
  "veneers",
  "whitening",
  "implants",
  "crowns",
  "braces",
  "invisalign",
] as const;
